// https://cdpn.io/RobVermeer/fullpage/japZpY
module.exports = function($) {

    class DragAndDrop {
        constructor() {
            this.DragAndDrop_settings = (typeof europeennes_draganddrop != 'undefined')? europeennes_draganddrop : {};
            this.DragAndDrop = {
                values: {
                    left: [],
                    right: [],
                },
                number: 0,
                correct_answer: 0,
                status: ''
            };

            this.LetzvoteEuropeennes = (typeof LetzvoteEuropeennes != 'undefined')? LetzvoteEuropeennes : {};

            this.Container = document.querySelector('.page-template-tpl-europeennes .block-pratique--draganddrop');

            if( this.Container == null ){
                return;
            }

            this.cardsContainer = document.querySelector('.cards');
            this.allCards = document.querySelectorAll('.card');
            this.addleft = document.getElementById('add-left');
            this.addright = document.getElementById('add-right');
            this.init();
            this.initCards();
            this.bind();
            this.right_answer = -1;
        }

        clear_all(){

            this.DragAndDrop = {
                values: {
                    left: [],
                    right: [],
                },
                number: 0,
                correct_answer: 0,
                status: ''
            };

            this.LetzvoteEuropeennes.score = 0;

            this.LetzvoteEuropeennes.trials = {
                bulletinVote: 0,
                quizz: 0,
                dragandrop: 0
            };

            // this.LetzvoteEuropeennes.trials.bulletinVote = 0;
            // this.LetzvoteEuropeennes.trials.quizz = 0;
            // this.LetzvoteEuropeennes.trials.dragandrop = 0;
            this.LetzvoteEuropeennes.number = 0;

            sessionStorage.setItem('EuropeennesDragAndDrop', JSON.stringify(this.DragAndDrop) );
            sessionStorage.setItem('LetzvoteEuropeennes', JSON.stringify(this.LetzvoteEuropeennes) );

            let OldCards = document.querySelectorAll('.card.completed');
            OldCards.forEach(function(elmt){
                elmt.classList.remove('completed');
                elmt.classList.remove('success');
                elmt.classList.remove('error');
                elmt.setAttribute('style','');
            })

            $('[data-group="pratique"]').removeClass('active');
            $('#pratique--1').addClass('active');

            this.right_answer = -1;
            this.initCards();
        }

        load(){
            let s = sessionStorage.getItem('LetzvoteEuropeennes');
            if( s ){
                this.LetzvoteEuropeennes = JSON.parse(s);
            }
        }

        init(){
            let s = sessionStorage.getItem('EuropeennesDragAndDrop');
            if (s) {
                this.DragAndDrop = JSON.parse(s);
            }
            this.load();
        }

        initCards() {

            if( this.Container == null ){
                return;
            }

            let _this = this;

            let newCards = document.querySelectorAll('.card:not(.completed)');
            let middel = this.cardsContainer.clientWidth / 2 + 170;

            newCards.forEach(function (card, index) {
                card.style.zIndex = _this.allCards.length - index;
                card.style.transform = 'scale(' + (6 - index) / 6 + ')';
                card.style.opacity = (6 - index) / 6;
                let w = card.clientWidth / 2 * -1;
                card.style.marginLeft = w + 'px';
            });

            let OldCards = document.querySelectorAll('.card.completed');

            if (OldCards.length == 0) {
                for (let i in this.DragAndDrop.values.left) {
                    let v = this.DragAndDrop.values.left[i];
                    let elmt = document.querySelector('.cards .card[data-item="' + v + '"]');
                    if (elmt) {
                        elmt.classList.add('completed');
                    }
                }
                for (let i in this.DragAndDrop.values.right) {
                    let v = this.DragAndDrop.values.right[i];
                    let elmt = document.querySelector('.cards .card[data-item="' + v + '"]');
                    if (elmt) {
                        elmt.classList.add('completed');
                    }
                }
                OldCards = document.querySelectorAll('.card.completed');
            }

            let posY = {
                left: 150,
                right: 150
            };
            let mT = {
                left: 0,
                right: 0
            };

            OldCards.forEach(function (card, index) {
                let item = parseInt(card.getAttribute('data-item'));

                let attrML = card.getAttribute('data-marginLeft');

                let marginleft = (attrML) ? parseInt(attrML) : -15 + Math.random() * (-5 + 15);
                if( card.offsetWidth != 0 ){
                    card.setAttribute('data-marginLeft', marginleft);
                }

                let attrMT = card.getAttribute('data-marginTop');
                let marginTop = (attrMT) ? parseInt(attrMT) : Math.floor(Math.random() * -15);
                card.setAttribute('data-marginTop', marginTop);

                if (_this.DragAndDrop.values.left.includes(item)) {
                    marginTop += mT.left;
                    mT.left = marginTop;
                }
                if (_this.DragAndDrop.values.right.includes(item)) {
                    marginTop += mT.right;
                    mT.right = marginTop;
                }

                card.style.marginLeft = marginleft + '%';
                card.style.marginTop = marginTop + 'px';

                card.classList.add('error');


                if (_this.DragAndDrop.values.left.includes(item) && _this.DragAndDrop_settings.values.left.includes(item)) {
                    card.classList.add('success');
                    card.classList.remove('error');
                }

                if (_this.DragAndDrop.values.right.includes(item) && _this.DragAndDrop_settings.values.right.includes(item)) {
                    card.classList.add('success');
                    card.classList.remove('error');
                }

                if (_this.DragAndDrop.values.left.includes(item)) {
                    card.style.left = '15%';
                    card.style.transform = 'translate(0,0) rotate(0deg)';

                    card.style.top = posY.left + 'px';
                    posY.left += card.offsetHeight;
                    card.classList.add('card-left');
                }

                if (_this.DragAndDrop.values.right.includes(item)) {
                    card.style.left = '74%';
                    card.style.transform = 'translate(0,0) rotate(0deg)';

                    card.style.top = posY.right + 'px';
                    posY.right += card.offsetHeight;
                    card.classList.add('card-right');
                }

                card.style.opacity = 1;

            });

            if( this.right_answer == 0 ){
                this.Container.querySelector('.drawing .bubble.success').classList.add('d-none');
                this.Container.querySelector('.drawing .bubble.error').classList.remove('d-none');
                this.Container.querySelector('.drawing img.success').classList.add('d-none');
                this.Container.querySelector('.drawing img.error').classList.remove('d-none');
                this.animation(0);
            } else if( this.right_answer == 1 ){
                this.Container.querySelector('.drawing .bubble.success').classList.remove('d-none');
                this.Container.querySelector('.drawing .bubble.error').classList.add('d-none');
                this.Container.querySelector('.drawing img.success').classList.remove('d-none');
                this.Container.querySelector('.drawing img.error').classList.add('d-none');
                this.animation(1);
            } else {
                this.Container.querySelector('.drawing .bubble.success').classList.add('d-none');
                this.Container.querySelector('.drawing .bubble.error').classList.add('d-none');
                this.Container.querySelector('.drawing img.success').classList.remove('d-none');
                this.Container.querySelector('.drawing img.error').classList.add('d-none');
            }

            if (this.DragAndDrop.number == this.DragAndDrop_settings.number) {
                let note = this.Container.querySelectorAll('.note');
                note.forEach(function (element, index) {
                    element.innerHTML = _this.DragAndDrop.correct_answer + " / " + _this.DragAndDrop.number;
                })
                if (this.DragAndDrop.status == 'successful') {
                    this.Container.querySelector('.message.alert-success').classList.remove('d-none');
                    this.Container.querySelector('.message.alert-warning').classList.add('d-none');
                    setTimeout(function() {
                        _this.Container.querySelector('.message.alert-success').scrollIntoView();
                    }, 800);
                } else if( this.DragAndDrop.status == 'failed' ) {
                    this.Container.querySelector('.message.alert-warning').classList.remove('d-none');
                    this.Container.querySelector('.message.alert-success').classList.add('d-none');
                    setTimeout(function() {
                        _this.Container.querySelector('.message.alert-warning').scrollIntoView();
                    }, 800);
                }
                document.querySelectorAll('.score_global').forEach(function(elmt, index){
                    elmt.innerHTML = _this.LetzvoteEuropeennes.score + " / " + _this.LetzvoteEuropeennes.total;
                });
            } else {
                this.Container.querySelector('.message.alert-success').classList.add('d-none');
                this.Container.querySelector('.message.alert-warning').classList.add('d-none');
            }

            this.Container.classList.add('loaded');
        }
        bind() {
            let _this = this;

            this.Container.querySelectorAll('.clear-draganddrop').forEach(function (el) {
                let __this = _this;
                el.addEventListener('click', function(e){
                    __this.load();
                    __this.LetzvoteEuropeennes.trials.dragandrop = 0;
                    __this.LetzvoteEuropeennes.number -= 1;
                    __this.LetzvoteEuropeennes.score -= __this.DragAndDrop.correct_answer;
                    sessionStorage.setItem('LetzvoteEuropeennes', JSON.stringify(__this.LetzvoteEuropeennes) );

                    __this.DragAndDrop = {
                        values: {
                            left: [],
                            right: [],
                        },
                        number: 0,
                        correct_answer: 0,
                        status: ''
                    };
                    sessionStorage.setItem('EuropeennesDragAndDrop', JSON.stringify(__this.DragAndDrop));

                    let OldCards = document.querySelectorAll('.card.completed');

                    OldCards.forEach(function(elmt){
                        elmt.classList.remove('completed');
                        elmt.classList.remove('success');
                        elmt.classList.remove('error');
                        elmt.setAttribute('style','');
                    })
                    document.querySelector('.block-pratique').scrollIntoView();
                    __this.right_answer = -1;
                    __this.initCards();
                    e.preventDefault();
                });
            })

            this.allCards.forEach(function (el) {
                let __this = _this;
                var hammertime = new Hammer(el);

                hammertime.on('pan', function (event) {
                    el.classList.add('moving');
                });

                hammertime.on('pan', function (event) {
                    if (event.deltaX === 0) return;
                    if (event.center.x === 0 && event.center.y === 0) return;

                    __this.Container.classList.toggle('tinder_right', event.deltaX > 0);
                    __this.Container.classList.toggle('tinder_left', event.deltaX < 0);

                    var xMulti = event.deltaX * 0.03;
                    var yMulti = event.deltaY / 80;
                    var rotate = xMulti * yMulti;

                    event.target.style.transform = 'translate(' + event.deltaX + 'px, ' + event.deltaY + 'px) rotate(' + rotate + 'deg)';
                });

                hammertime.on('panend', function (event) {
                    el.classList.remove('moving');
                    __this.Container.classList.remove('tinder_left');
                    __this.Container.classList.remove('tinder_right');

                    let keep = Math.abs(event.deltaX) < 80;
                    let item = parseInt(event.target.getAttribute('data-item'));

                    event.target.classList.toggle('completed', !keep);

                    if (keep) {
                        event.target.style.transform = '';
                    } else {
                        __this.DragAndDrop.number += 1;
                        if (event.deltaX < 0) {
                            __this.DragAndDrop.values.left.push(item);
                            if (__this.DragAndDrop.values.left.includes(item) && __this.DragAndDrop_settings.values.left.includes(item)) {
                                __this.DragAndDrop.correct_answer += 1;
                                __this.right_answer = 1;
                            } else {
                                __this.right_answer = 0;
                            }
                        }

                        if (event.deltaX > 0) {
                            __this.DragAndDrop.values.right.push(item);
                            if (__this.DragAndDrop.values.right.includes(item) && __this.DragAndDrop_settings.values.right.includes(item)) {
                                __this.DragAndDrop.correct_answer += 1;
                                __this.right_answer = 1;
                            } else {
                                __this.right_answer = 0;
                            }
                        }

                        if (__this.DragAndDrop.number == __this.DragAndDrop_settings.number) {
                            if (__this.DragAndDrop.correct_answer >= __this.DragAndDrop_settings.number / 2) {
                                __this.DragAndDrop.status = 'successful';
                            } else {
                                __this.DragAndDrop.status = 'failed';
                            }
                            sessionStorage.setItem('EuropeennesDragAndDrop', JSON.stringify(__this.DragAndDrop));

                            __this.LetzvoteEuropeennes.trials.dragandrop = __this.DragAndDrop.correct_answer;
                            __this.LetzvoteEuropeennes.number += 1;
                            __this.LetzvoteEuropeennes.score += __this.DragAndDrop.correct_answer;
                            sessionStorage.setItem('LetzvoteEuropeennes', JSON.stringify(__this.LetzvoteEuropeennes) );
                        }

                        __this.initCards();
                    }
                });
            });

            const addleftListener = this.createButtonListener(false);
            const addrightListener = this.createButtonListener(true);

            this.addleft.addEventListener('click', addleftListener);
            this.addright.addEventListener('click', addrightListener);
        }
        createButtonListener(right) {
            let _this = this;
            return function (event) {

                _this.load();

                let cards = document.querySelectorAll('.card:not(.completed)');

                if (!cards.length) return false;

                let card = cards[0];

                let item = parseInt(card.getAttribute('data-item'));

                card.classList.add('completed');

                _this.DragAndDrop.number += 1;

                if (right) {
                    _this.DragAndDrop.values.right.push(item);
                    if (_this.DragAndDrop.values.right.includes(item) && _this.DragAndDrop_settings.values.right.includes(item)) {
                        _this.DragAndDrop.correct_answer += 1;
                        _this.right_answer = 1;
                    } else {
                        _this.right_answer = 0;
                    }
                } else {
                    _this.DragAndDrop.values.left.push(item);
                    if (_this.DragAndDrop.values.left.includes(item) && _this.DragAndDrop_settings.values.left.includes(item)) {
                        _this.DragAndDrop.correct_answer += 1;
                        _this.right_answer = 1;
                    } else {
                        _this.right_answer = 0;
                    }
                }

                if (_this.DragAndDrop.number == _this.DragAndDrop_settings.number) {
                    if (_this.DragAndDrop.correct_answer >= _this.DragAndDrop_settings.number / 2) {
                        _this.DragAndDrop.status = 'successful';
                    } else {
                        _this.DragAndDrop.status = 'failed';
                    }
                    sessionStorage.setItem('EuropeennesDragAndDrop', JSON.stringify(_this.DragAndDrop));

                    _this.LetzvoteEuropeennes.trials.dragandrop = _this.DragAndDrop.correct_answer;
                    _this.LetzvoteEuropeennes.number += 1;
                    _this.LetzvoteEuropeennes.score += _this.DragAndDrop.correct_answer;
                    sessionStorage.setItem('LetzvoteEuropeennes', JSON.stringify(_this.LetzvoteEuropeennes) );
                }

                _this.initCards();

                event.preventDefault();
            };
        }

        animation(status){
            let div = document.getElementById('animation');
            document.getElementById('animation').classList.add("animation-"+status);
            setTimeout(function(){
                div.classList.remove("animation-"+status);
            },1000);
        }
    }

    return new DragAndDrop();

}

// window.addEventListener('load', function(){
// }, false );
